var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.652,
    height: 39,
    viewBox: "0 0 46.652 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_70_272",
    "data-name": "Component 70 \\u2013 272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.652,
    height: 39,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.652,
    height: 38,
    rx: 4.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Component_78_2",
    "data-name": "Component 78 \\u2013 2",
    transform: "translate(7.232 6.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9103",
    "data-name": "Path 9103",
    d: "M32.571,197.246a.539.539,0,0,1-.384-.917l5.134-5.219a.539.539,0,1,1,.768.755l-5.134,5.219A.537.537,0,0,1,32.571,197.246Z",
    transform: "translate(-27.94 -168.161)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9102",
    "data-name": "Path 9102",
    d: "M32.338,13.3a.53.53,0,0,0,0-.153c0-.008,0-.015,0-.022a.541.541,0,0,0-.066-.166c0-.006,0-.012-.007-.018s-.014-.013-.02-.021a.47.47,0,0,0-.036-.052.553.553,0,0,0-.061-.052c-.011-.009-.021-.019-.032-.027a.534.534,0,0,0-.157-.075c-.01,0-.02,0-.03-.005a.53.53,0,0,0-.145-.012l-.048,0c-.014,0-.028,0-.042,0L.438,19.69a.539.539,0,0,0-.138,1l8.45,4.548,2.632,8.391c0,.009.009.015.012.024a.762.762,0,0,0,.1.17c.008.009.011.02.019.029s.018.01.026.017a.537.537,0,0,0,.117.077.483.483,0,0,0,.049.025.53.53,0,0,0,.186.036h.012a.53.53,0,0,0,.183-.038c.015-.006.027-.016.041-.023a.537.537,0,0,0,.125-.084c.007-.006.017-.009.023-.016l4.314-4.386,8.327,4.482a.539.539,0,0,0,.768-.306L32.319,13.4c.005-.016.005-.032.009-.048A.462.462,0,0,0,32.338,13.3Zm-4.507,1.372L9.2,24.26l-7.12-3.833Zm-1.119,1.789L13.239,26.792l0,0a.527.527,0,0,0-.106.113l-.018.027c-.006.01-.014.019-.02.029a.528.528,0,0,0-.044.111l0,.005-1.192,4.457-2.007-6.4ZM12.944,31.635l.967-3.618,1.694.912Zm11.921,1.054L14.556,27.14l16.2-12.425Z",
    transform: "translate(-0.017 -12.693)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9104",
    "data-name": "Path 9104",
    d: "M98.694,180.7a.539.539,0,0,1-.384-.917l5.134-5.218a.539.539,0,0,1,.768.755l-5.133,5.219A.538.538,0,0,1,98.694,180.7Z",
    transform: "translate(-85.609 -153.732)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9105",
    "data-name": "Path 9105",
    d: "M20.025,155.538a.539.539,0,0,1-.384-.917l3.752-3.814a.539.539,0,1,1,.768.755l-3.752,3.814A.537.537,0,0,1,20.025,155.538Z",
    transform: "translate(-16.998 -133.011)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/SendMail.42a8d3a18ee150d2c1c228ffb0180ecc.svg";
export { ForwardRef as ReactComponent };